var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateOfferToSeeQrPvr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#FFFDF5",
    stroke: "#FFCB05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 19.25H19.25V20.75H20.75V19.25Z",
    fill: "#C23100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 19C16 17.3432 17.3432 16 19 16H24V24H16V19ZM19 18C18.4477 18 18 18.4477 18 19V22H22V18H19Z",
    fill: "#C23100",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 29.25H20.75V30.75H19.25V29.25Z",
    fill: "#C23100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26H24V34H19C17.3432 34 16 32.6569 16 31V26ZM18 28V31C18 31.5523 18.4477 32 19 32H22V28H18Z",
    fill: "#FFCB05",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 19.25H30.75V20.75H29.25V19.25Z",
    fill: "#C23100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 16H26V24H34V19C34 17.3432 32.6569 16 31 16ZM28 22V18H31C31.5523 18 32 18.4477 32 19V22H28Z",
    fill: "#FFCB05",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7539 29.25H29.2539V30.75H30.7539V29.25Z",
    fill: "#C23100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0051 29.5014L34.0029 31.0043C34.0005 32.6595 32.6581 34 31.0029 34H29.4736V32H31.0029C31.5546 32 32.0021 31.5532 32.0029 31.0014L32.0051 29.4985L34.0051 29.5014ZM29.4736 26H26V29H28V28H29.4736V26ZM31 26H34V28H31V26ZM28 34V30.5H26V34H28Z",
    fill: "#C23100",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateOfferToSeeQrPvr);
export default __webpack_public_path__ + "static/media/activate-offer-to-see-qr-pvr.42bbaff17d906a9f28b83cd34dace824.svg";
export { ForwardRef as ReactComponent };